/**
 * Created by filatov on 17.09.2015.
 */
import CostCSVPreviewBaseColumnsStrategy from './CostCSVPreviewBaseColumnsStrategy'

export default function CostCSVPreviewUserByGroupsOnlyColumnsStrategy() {}

CostCSVPreviewUserByGroupsOnlyColumnsStrategy.prototype = new CostCSVPreviewBaseColumnsStrategy();

CostCSVPreviewUserByGroupsOnlyColumnsStrategy.prototype.init = function ({showAverageRates, showSubtotalsByDepartments, showOthers})
{
    CostCSVPreviewBaseColumnsStrategy.prototype.init.call( this, false, showAverageRates);
    this.showSubtotalsByDepartments = showSubtotalsByDepartments;
    this.showOthers = showOthers
    return this;
};

CostCSVPreviewUserByGroupsOnlyColumnsStrategy.prototype.getNumOfDetailsColumns = function ()
{
    return 3
};

CostCSVPreviewUserByGroupsOnlyColumnsStrategy.prototype.addSecondHeaderRowDataCells = function(row) {
    ReportPreviewUtils.addEmptyCells(row, this.getOverallColumnsCount())
    let numGroupingHeaders = this.getNumOfDetailsColumns()
    if (this.showOthers) numGroupingHeaders--
    for (let i = 0; i < numGroupingHeaders; i++) {
        this.addCell(row, this.message("user.group"))
    }
    if (this.showOthers) ReportPreviewUtils.addEmptyCell(row)
}

CostCSVPreviewUserByGroupsOnlyColumnsStrategy.prototype.addFirstHeaderRowDataCells = function(row) {
    this.addOverallHeaderCells(row)

    let numOfHeaderSubColumns = this.getNumOfDetailsColumns()
    if (this.showSubtotalsByDepartments) {
        this.addCell(row, this.message("report.subtotal"))
        numOfHeaderSubColumns--
    }
    if (this.showOthers) numOfHeaderSubColumns--
    for (let i = 0; i < numOfHeaderSubColumns; i++) {
        this.addCell(row, this.message("report.user"))
    }
    if (this.showOthers) this.addCell(row, this.message("report.common.others"))
}

CostCSVPreviewUserByGroupsOnlyColumnsStrategy.prototype.getCountGroupingRows = function ()
{
    return 2;
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/cost/CostCSVPreviewUserByGroupsOnlyColumnsStrategy.js